export function isValidHttpUrl(string) {
  let url;
  try {
    url = new URL(string);
  } catch (_) {
    /* istanbul ignore next */
    return false;
  }
  return url.protocol === 'http:' || url.protocol === 'https:';
}
//# sourceMappingURL=isValidHttpUrl.js.map